// En desarrollo: .env.development → REACT_APP_API_URL (p. ej. http://localhost:8080/api/v1)
// En Netlify: define REACT_APP_API_URL en Site settings → Environment variables (URL pública de Railway)
const fromEnv = process.env.REACT_APP_API_URL?.trim();
export const API_URL =
	fromEnv?.replace(/\/$/, '') ||
	'https://ivan-blanco-server.up.railway.app/api/v1';
